import store from '../store';

import adminRoutes from './admin.js';
import clientRoutes from './clients.js';
import groupRoutes from './groups.js';
import orgRoutes from './orgs.js';
import physicianRoutes from './physicians.js';
import userRoutes from './users.js';

const routes =  [

	...adminRoutes,
	...clientRoutes,
	...groupRoutes,
	...orgRoutes,
	...physicianRoutes,
	...userRoutes,


	{ 
		path: '/assets',
		name: 'assets.index', 
		component: require('../pages/assets/AssetsIndex.vue').default
	},	

	{ 
		path: '/campaigns',
		name: 'campaigns.index', 
		component: require('../pages/campaigns/CampaignsIndex.vue').default
	},	

	{ 
		path: '/campaigns/:id',
		name: 'campaigns.show', 
		component: require('../pages/campaigns/CampaignItem.vue').default,
		props(route) {
			const props = { ...route.params };
			props.id = +props.id;
			return props;
		},
	},	

	{ 
		path: '/checkins',
		name: 'checkins.index', 
		component: require('../pages/checkins/CheckinsIndex.vue').default
	},	

	{ 
		path: '/goals',
		name: 'goals.index', 
		component: require('../pages/goals/GoalsIndex.vue').default
	},	

	{ 
		path: '/reports',
		name: 'reports.index', 
		component: require('../pages/reports/ReportsIndex.vue').default
	},	

	{ 
		path: '/reports/create',
		name: 'reports.create', 
		component: require('../pages/reports/ReportItemCreate.vue').default,
		beforeEnter: (to, from, next) => {
			if (!store.state.perms.can_create_report) {
				next('/error')
			}
			else {
				next()
			}
		}
	},	


	{ 
		path: '/reports/test',
		name: 'reports.test', 
		component: require('../pages/reports/ReportTest.vue').default,
		// props(route) {
		// 	const props = { ...route.params };
		// 	props.id = +props.id;
		// 	return props;
		// },
	},	

	
	{ 
		path: '/reports/:id',
		name: 'reports.show', 
		component: require('../pages/reports/ReportItem.vue').default,
		props(route) {
			const props = { ...route.params };
			props.id = +props.id;
			return props;
		},
	},	

	{ 
		path: '/reports/:id/edit',
		name: 'reports.edit', 
		component: require('../pages/reports/ReportItemEdit.vue').default,
		beforeEnter: (to, from, next) => {
			if (!store.state.perms.can_create_report) {
				next('/error')
			}
			else {
				next()
			}
		}
	},	


	{ 
		path: '/routes',
		name: 'routes.index', 
		component: require('../pages/routes/RoutesIndex.vue').default
	},	

	{ 
		path: '/routes/:id',
		name: 'routes.show', 
		component: require('../pages/routes/RouteItem.vue').default,
		props(route) {
			const props = { ...route.params };
			props.id = +props.id;
			return props;
		},
	},	

	{ 
		path: '/tasks', 
		name: 'tasks', 
		component: require('../pages/tasks/TaskManager.vue').default
	},

	{ 
		path: '/error',
		name: 'error', 
		component: require('../pages/ErrorGeneric.vue').default
	},

	{ 
		path: '/home', 
		name: 'home', 
		component: require('../pages/HomeDashboard.vue').default 
	},

	{	
		path: '/', redirect: { name: 'home' }
	},


	{ 
		path: '*', 
		component: require('../pages/ErrorNotFound.vue').default
	}
	
];

export default routes;